import { varAlpha } from 'minimal-shared/utils'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

import brandConfig from 'brandConfig'
import Footer from '../../components/shared/footer/Footer'
import MainBanner from '../../components/shared/mainBanner/MainBanner'

// ----------------------------------------------------------------------

export function AuthSplitSection({ sx, layoutQuery = 'md', ...other }) {
  const { t } = useTranslation()
  const { name } = brandConfig
  return (
    <Box
      sx={[
        (theme) => ({
          ...theme.mixins.bgGradient({
            images: [
              `linear-gradient(0deg, ${varAlpha(theme.vars.palette.background.defaultChannel, 0.92)}, ${varAlpha(theme.vars.palette.background.defaultChannel, 0.92)})`,
              `url(/assets/background/background-3-blur.webp)`
            ]
          }),
          px: 3,
          pb: 3,
          width: 1,
          maxWidth: 480,
          display: 'none',
          position: 'relative',
          pt: 'var(--layout-header-desktop-height)',
          [theme.breakpoints.up(layoutQuery)]: {
            gap: 8,
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center'
          }
        }),
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
      {...other}
    >
      <div>
        <Typography variant='h3' sx={{ textAlign: 'center' }}>
          {name}
        </Typography>

        <Typography
          sx={{ color: 'text.secondary', textAlign: 'center', mt: 2 }}
        >
          {t('brand:welcome.subtitle')}
        </Typography>
      </div>
      <MainBanner />
      <Footer />
    </Box>
  )
}
